import React from 'react';
import classNames from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';
import './style.scss';

const OverviewIntro = ({ className, type, children, title, link, subTitle, ...props }) => {
  const classes = classNames('OverviewIntro', className, `OverviewIntro--${type}`);
  return (
    <div className={classes} {...props}>
      <div className="OverviewIntro__content">
        <div className="OverviewIntro__contentWrapper">
          {children}
        </div>
        {title && link ? (
          <div className="OverviewIntro__Button">
            <CoreLink className="Button hidden-break Button--primary Button--inverted" to={link}>{subTitle}</CoreLink>
            <CoreLink className="Button hidden-other Button--primary Button--inverted" to={link}>Bekijk alles</CoreLink>
          </div>
        ) : null}
      </div>
    </div>
  );
};

OverviewIntro.defaultProps = {
  type: 'article',
};


export default OverviewIntro;
